// extracted by mini-css-extract-plugin
export default {"UITourContainer":"UITourContainer_Cfate","TourHeader":"TourHeader_IPshj","TourTitle":"TourTitle_Nunns","titleText":"titleText_PTyNY","tourCloseModalWrap":"tourCloseModalWrap_vxaE9"};